import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Base64 } from 'js-base64';
import * as sha512 from 'js-sha512';
import * as JsEncryptModule from 'jsencrypt';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable, of, throwError, timer } from 'rxjs';
import { catchError, finalize, mergeMap, tap } from 'rxjs/operators';
import { default as olarconfig } from '../../assets/olarconfig.json';
import { EcomHtmlUtils } from '../ecom-base-entities/ecom-common/ecom-htmlUtils.services';
import { EcomNetworkUtils } from '../ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { LoadingService } from '../ecom-shared/loading-component/loading-service';
import { EComWebStorage } from './ecom-webstorage.services';
export let browserRefresh = false;
// import * as sha256 from 'js-sha256';

@Injectable()
export class EComService implements OnInit, OnDestroy {
  public convertToServerTimezone(value) {
    if (value) {
      // value = value.toLocaleString('en-US', { timeZone: Constants.SERVER_TIMEZONE_NAME });

      value = this.datepipe.transform(value, 'yyyy-MM-dd HH:mm:ss');
      return value;
    }
  }
  maxRetryAttempts = 3;
  loadingPage = {
    message: 'loading please wait',
    loading: true
  };
  isLoading: boolean;
  //requestTokenBSubject = new BehaviorSubject('');

  constructor(public router: Router, private http: HttpClient, public htmlUtil: EcomHtmlUtils, private localSt: LocalStorageService,
    public commonLoading: LoadingService, private webstorage: EComWebStorage,
    public datepipe: DatePipe) {
  }
  ngOnDestroy() {

  }
  // tslint:disable-next-line:contextual-lifecycle
  ngOnInit() {

  }

  httpGet(url: string, option: any, loading: boolean = false): Observable<any> {
    this.isLoading = true;
    if (loading) {
      this.commonLoading.show = true;
    }
    return this.http.get<any>(this.GetOlarConfigValue('serverurl') + url)
      .pipe(
        tap(result => {
          if (loading) {
            // give 1 second delay to render the view
            let temp = this;
            setTimeout(() => {
              temp.commonLoading.show = false;
            }, 1000);
            //this.commonLoading.show = false;
          }
          this.isLoading = false;
          return result;
        }),
        // retryWhen(genericRetryStrategy({ maxRetryAttempts: 3, scalingDuration: 1000, excludedStatusCodes: [], urlname: url })),
        catchError(error => of(error))
      );

  }

  httpPost(url: string, data: any, option: any, loading: boolean = false, loadingDisplay = false): Observable<any> {
    this.isLoading = true;
    if (loading) {
      this.commonLoading.show = true;
    }
    return this.http.post(this.GetOlarConfigValue('serverurl') + url, data)
      .pipe(
        tap(result => {
          if (!loadingDisplay) {
            if (loading) {
              // give 1 second delay to render the view
              let temp = this;
              setTimeout(() => {
                temp.commonLoading.show = false;
              }, 350);
              //this.commonLoading.show = false;
            }
          }
          this.isLoading = false
          return result;
        }),
        // retryWhen(genericRetryStrategy({ maxRetryAttempts: 3, scalingDuration: 1000, excludedStatusCodes: [], urlname: url })),
        catchError(error => {
          this.isLoading = false;
          this.commonLoading.show = false;
          console.log('Error in httpPost: ', error);
          return of(error);
        })
      );

  }



  httpGetOuter(url: string, option: any, loading: boolean = false): Observable<any> {

    if (loading) {
      this.commonLoading.show = true;
    }
    return this.http.get<any>(url)
      .pipe(
        tap(result => {
          if (loading) {
            // give 1 second delay to render the view
            let temp = this;
            setTimeout(() => {
              temp.commonLoading.show = false;
            }, 1000);
            //this.commonLoading.show = false;
          }
          return result;
        }),
        // retryWhen(genericRetryStrategy({ maxRetryAttempts: 3, scalingDuration: 1000, excludedStatusCodes: [], urlname: url })),
        catchError(error => of(error))
      );

  }

  httpPostOuter(url: string, data: any, option: any, loading: boolean = false): Observable<any> {
    if (loading) {
      this.commonLoading.show = true;
    }
    return this.http.post(url, data)
      .pipe(
        tap(result => {
          if (loading) {
            // give 1 second delay to render the view
            let temp = this;
            setTimeout(() => {
              temp.commonLoading.show = false;
            }, 1000);
            //this.commonLoading.show = false;
          }
          return result;
        }),
        // retryWhen(genericRetryStrategy({ maxRetryAttempts: 3, scalingDuration: 1000, excludedStatusCodes: [], urlname: url })),
        catchError(error => of(error))
      );

  }

  httpGetOuterResponseHeader(url: string, option: any, loading: boolean = false): Observable<any> {

    if (loading) {
      this.commonLoading.show = true;
    }
    return this.http.get<any>(url, { observe: 'response' as 'body' })
      .pipe(
        tap(result => {
          if (loading) {
            // give 1 second delay to render the view
            let temp = this;
            setTimeout(() => {
              temp.commonLoading.show = false;
            }, 1000);
            //this.commonLoading.show = false;
          }
          return result;
        }),
        // retryWhen(genericRetryStrategy({ maxRetryAttempts: 3, scalingDuration: 1000, excludedStatusCodes: [], urlname: url })),
        catchError(error => of(error))
      );

  }

  httpPostOuterResponseHeader(url: string, data: any, option: any, loading: boolean = false): Observable<any> {
    if (loading) {
      this.commonLoading.show = true;
    }
    return this.http.post(url, data, { observe: 'response' as 'body' })
      .pipe(
        tap(result => {
          if (loading) {
            // give 1 second delay to render the view
            let temp = this;
            setTimeout(() => {
              temp.commonLoading.show = false;
            }, 1000);
            //this.commonLoading.show = false;
          }
          return result;
        }),
        // retryWhen(genericRetryStrategy({ maxRetryAttempts: 3, scalingDuration: 1000, excludedStatusCodes: [], urlname: url })),
        catchError(error => of(error))
      );

  }



  handleError(error: Response) {
  }


  /*
  encryptData(data, encryptSecretKey) {
      try {
          // this.encrypt(JSON.stringify(data),encryptSecretKey);
          // var hash = CryptoJS.HmacSHA256("Message", "Secret Passphrase");
          // return CryptoJS.HmacSHA512(JSON.stringify(data), encryptSecretKey);
          // let hash = CryptoJS.HmacSHA512(JSON.stringify(data), encryptSecretKey);
          return CryptoJS.HmacSHA512(JSON.stringify(data), encryptSecretKey).toString(CryptoJS.enc.Base64);
          // return CryptoJS.sha256.encrypt(JSON.stringify(data), encryptSecretKey).toString();
          //return CryptoJS.AES.encrypt(JSON.stringify(data), encryptSecretKey).toString();
      } catch (e) {
      } 
  }
  */

  encryptWithKey(data): string {
    try {
      // JS Encrypt
      //const key = this.getCookie('olarkey');
      const key = this.webstorage.localSt_olar_key;
      var encrypt = new JsEncryptModule.JSEncrypt();
      //const encrypt = new jsencrypt(key);
      encrypt.setPublicKey(key);
      const encrypted: any = encrypt.encrypt(data);
      return encrypted;
    } catch (e) {
    }
  }

  /*
  decryptData(data, encryptSecretKey) {
      try {
          const bytes = CryptoJS.AES.decrypt(data, encryptSecretKey);
          if (bytes.toString()) {
              return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          }
          return data;
      } catch (e) {
      }
  }
  */

  generateSHA512Hash(message) {
    return sha512.sha512(message);
  }


  redirecTo(pagename) {
    switch (pagename) {
      case 'cart':
        this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
        break;
      case 'checkout':
        this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
        break;
      case 'home':
        this.router.navigate(['home']);
        break;
      case 'networkissue':
        this.router.navigate(['networkissue']);
        break;
      case 'profile':
        this.router.navigate(['profile']);
        break;
      case 'orders':
        this.router.navigate(['orders']);
        break;
      case 'scan':
        this.router.navigate(['scan']);
        break;
      case 'profile-edit':
        this.router.navigate(['profile-edit']);
        break;
      case 'payment-methods':
        this.router.navigate(['payment-methods', this.webstorage.sessionSt_company_clicked]);
        break;
      case 'stores':
        this.router.navigate(['stores']);
        break;
      // case 'store':
      //   this.router.navigate(['store']);
      //   break;
      case 'login':
        this.router.navigate(['login']);
        break;
      case 'signup':
        this.router.navigate(['signup']);
        break;
      case 'forgot':
        this.router.navigate(['forgot']);
        break;
      case 'items':
        this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
        break;
      case 'item-details':
        this.router.navigate(['item-details']);
        break;
      case 'status-dinein':
        this.router.navigate(['status-dinein']);
        break;
      case 'status-collection':
        this.router.navigate(['status-collection']);
        break;
      case 'status-delivery':
        this.router.navigate(['status-delivery']);
        break;
        break;
      case 'confirm-reservation':
        this.router.navigate(['confirm-reservation']);
        break;
      case 'user-reservation':
        this.router.navigate(['user-reservation']);
        break;
      case 'store-payment':
        this.router.navigate(['store-payment']);
        break;
      case 'checkout':
        this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
        break;
    }
  }

  scanPageRedirect(qrcodescan) {
    //if (this.webstorage.sessionSt_qr_scan_current_page) {
    //  const currentPage: string = this.webstorage.sessionSt_qr_scan_current_page;
    //  this.redirecTo(currentPage.replace('/', ''));
    //}
  }

  stringCompare(id1: string, id2: string): any {
    if (id1 && id2) {
      if (id1 === id2) {
        return true;
      }
      else {
        return false;
      }
    } else {
      return false;
    }
  }

  logconsole(message) {
    let log = this.GetOlarConfigValue('logconsole');
    if (log) {
    }
  }

  // Method to get the user orders based on clientid
  getUserOrders() {
    const clientId = this.webstorage.localSt_client_id;
    const userId = this.webstorage.localSt_user_id;
    this.httpGet(EcomNetworkUtils.GET_USER_ORDERS_COUNT + '?Id=' + clientId, '', false).subscribe((response) => {
      if (response.isSuccess) {
        let counts = response.value.split('@');
        if (counts.length > 0) {
          this.webstorage.sessionSt_order_count = counts[0];
          this.webstorage.sessionSt_Current_Order_Count = counts[0];
          this.webstorage.sessionSt_Past_Order_Count = counts[1];
          this.webstorage.sessionSt_upcoming_reservation_Count = counts[2];
        }
      }
    });
  }

  // Method to generate the client id and key
  // generateKey() {
  //     if (!this.webstorage.localSt_client_id || !this.getCookie('olarkey')) {
  //         const url = EcomNetworkUtils.POST_GENERATEKEY;
  //         this.httpPost(url, {}, '', true).subscribe((response) => {
  //             if (response.isSuccess) {
  //                 if (!this.webstorage.localSt_client_id) {
  //                     this.webstorage.localSt_client_id = response.listValue.oock_client_id;
  //                 }
  //                 // store public key
  //                 this.setCookie('olarkey', response.listValue.oock_public_key, 24);
  //                 const input = {
  //                     ClientId: this.webstorage.localSt_client_id
  //                 }
  //             }
  //         });
  //     }
  // }

  getRequestAuthToken(input) {
    const url = EcomNetworkUtils.POST_REQUEST_TOKEN;
    this.httpPost(url, input, '', true).subscribe((response) => {
      if (response.isSuccess) {
        //this.requestTokenBSubject.next(response.value);
        this.setCookie('request', response.value, 1);
      }
    });
  }

  GetCountryCurrency(coutryCode: string): any {
    let currency: any = 'RM';
    switch (coutryCode) {
      case 'MY':
        currency = 'RM';
      default:
        currency = 'RM';
    }
    return currency;
  }

  GetOlarConfigValue(key: string): any {
    let configValue: any = '';
    const environment = olarconfig.Environment;
    switch (environment) {
      case 'Development':
        if (key === 'merchantmate') {
          configValue = olarconfig.Development.merchantmate;
        } else if (key === 'serverurl') {
          configValue = olarconfig.Development.serverurl;
        } else if (key === 'azureapi_azureprimarykey') {
          configValue = olarconfig.Development.azureapi.azureprimarykey;
        } else if (key === 'azureapi_azureapiversion') {
          configValue = olarconfig.Development.azureapi.azureapiversion;
        } else if (key === 'googleapi_gogetapitoken') {
          configValue = olarconfig.Development.googleapi.gogetapitoken;
        } else if (key === 'googleapi_googlemapsapikey') {
          configValue = olarconfig.Development.googleapi.googlemapsapikey;
        } else if (key === 'rhPayments_merchant_id') {
          configValue = olarconfig.Development.rhPayments.merchant_id;
        } else if (key === 'rhPayments_merchant_key_key_index1') {
          configValue = olarconfig.Development.rhPayments.merchant_key.key_index1;
        } else if (key === 'rhPayments_merchant_key_key_index2') {
          configValue = olarconfig.Development.rhPayments.merchant_key.key_index2;
        } else if (key === 'rhPayments_merchant_key_key_index3') {
          configValue = olarconfig.Development.rhPayments.merchant_key.key_index3;
        } else if (key === 'rhPayments_paymentfrontreturnurl') {
          configValue = olarconfig.Development.rhPayments.paymentfrontreturnurl;
        } else if (key === 'rhPayments_paymentbackendurl') {
          configValue = olarconfig.Development.rhPayments.paymentbackendurl;
        } else if (key === 'rhPayments_paymentrequesturl') {
          configValue = olarconfig.Development.rhPayments.paymentrequesturl;
        } else if (key === 'rhPayments_paymentrequeryurl') {
          //configValue = olarconfig.Development.rhPayments.paymentrequeryurl;
        } else if (key === 'cookiename') {
          configValue = olarconfig.Development.cookiename;
        } else if (key === 'logconsole') {
          configValue = olarconfig.Development.logconsole;
        } else if (key === 'AmBank_MerchantName') {
          configValue = olarconfig.Development.AmBank.MerchantName;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Development.AmBank.MID;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Development.AmBank.MID;
        } else if (key === 'AmBank_TID') {
          configValue = olarconfig.Development.AmBank.TID;
        } else if (key === 'AmBank_MerchantAccountNo') {
          configValue = olarconfig.Development.AmBank.MerchantAccountNo;
        } else if (key === 'AmBank_TxnPassword') {
          configValue = olarconfig.Development.AmBank.TxnPassword;
        } else if (key === 'AmBank_PaymentType') {
          configValue = olarconfig.Development.AmBank.PaymentType;
        } else if (key === 'AmBank_AllowSales') {
          configValue = olarconfig.Development.AmBank.AllowSales;
        } else if (key === 'AmBank_UseOwnMPI') {
          configValue = olarconfig.Development.AmBank.UseOwnMPI;
        } else if (key === 'AmBank_Is3DEnabled') {
          configValue = olarconfig.Development.AmBank.Is3DEnabled;
        } else if (key === 'AmBank_sale_url') {
          configValue = olarconfig.Development.AmBank.sale_url;
        } else if (key === 'AmBank_return_url') {
          configValue = olarconfig.Development.AmBank.return_url;
        } else if (key === 'ipgeolocation_key') {
          configValue = olarconfig.Development.ipgeolocation_key;
        } else if (key === 'checkoutexpiryInMins') {
          configValue = olarconfig.Development.checkoutexpiryInMins;
        } else if (key === 'cartexpiryInMins') {
          configValue = olarconfig.Development.cartexpiryInMins;
        } else if (key === 'PaymentGateway') {
          configValue = olarconfig.Development.PaymentGateway;
        } else if (key === 'ghl_merchant_id') {
          configValue = olarconfig.Development.GHL.merchant_id;
        } else if (key === 'ghl_password') {
          configValue = olarconfig.Development.GHL.password;
        } else if (key === 'ghl_merchantreturnurl') {
          configValue = olarconfig.Development.GHL.merchantreturnurl;
        } else if (key === 'ghl_merchantcallbackurl') {
          configValue = olarconfig.Development.GHL.merchantcallbackurl;
        } else if (key === 'ghl_paymentrequesturl') {
          configValue = olarconfig.Development.GHL.paymentrequesturl;
        } else if (key === 'ghl_timeout') {
          configValue = olarconfig.Development.GHL.timeout;
        } else if (key === 'ghl_merchantapprovedurl') {
          configValue = olarconfig.Development.GHL.merchantapprovedurl;
        } else if (key === 'ghl_merchantunapprovedurl') {
          configValue = olarconfig.Development.GHL.merchantunapprovedurl;
        } else if (key === 'FACEBOOK_APP_ID') {
          configValue = olarconfig.Development.FACEBOOK_APP_ID;
        } else if (key === 'GOOGLE_APP_ID') {
          configValue = olarconfig.Development.GOOGLE_APP_ID;
        } else if (key === 'PREFIX_ROUTING') {
          configValue = olarconfig.Development.PREFIX_ROUTING;
        }
        break;
      case 'Testing':
        if (key === 'merchantmate') {
          configValue = olarconfig.Testing.merchantmate;
        } else if (key === 'serverurl') {
          configValue = olarconfig.Testing.serverurl;
        } else if (key === 'azureapi_azureprimarykey') {
          configValue = olarconfig.Testing.azureapi.azureprimarykey;
        } else if (key === 'azureapi_azureapiversion') {
          configValue = olarconfig.Testing.azureapi.azureapiversion;
        } else if (key === 'googleapi_gogetapitoken') {
          configValue = olarconfig.Testing.googleapi.gogetapitoken;
        } else if (key === 'googleapi_googlemapsapikey') {
          configValue = olarconfig.Testing.googleapi.googlemapsapikey;
        } else if (key === 'rhPayments_merchant_id') {
          configValue = olarconfig.Testing.rhPayments.merchant_id;
        } else if (key === 'rhPayments_merchant_key_key_index1') {
          configValue = olarconfig.Testing.rhPayments.merchant_key.key_index1;
        } else if (key === 'rhPayments_merchant_key_key_index2') {
          configValue = olarconfig.Testing.rhPayments.merchant_key.key_index2;
        } else if (key === 'rhPayments_merchant_key_key_index3') {
          configValue = olarconfig.Testing.rhPayments.merchant_key.key_index3;
        } else if (key === 'rhPayments_paymentfrontreturnurl') {
          configValue = olarconfig.Testing.rhPayments.paymentfrontreturnurl;
        } else if (key === 'rhPayments_paymentbackendurl') {
          configValue = olarconfig.Testing.rhPayments.paymentbackendurl;
        }
        else if (key === 'rhPayments_paymentrequesturl') {
          configValue = olarconfig.Testing.rhPayments.paymentrequesturl;
        } else if (key === 'rhPayments_paymentrequeryurl') {
          //configValue = olarconfig.Testing.rhPayments.paymentrequeryurl;
        } else if (key === 'cookiename') {
          configValue = olarconfig.Testing.cookiename;
        } else if (key === 'logconsole') {
          configValue = olarconfig.Testing.logconsole;
        } else if (key === 'AmBank_MerchantName') {
          configValue = olarconfig.Testing.AmBank.MerchantName;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Testing.AmBank.MID;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Testing.AmBank.MID;
        } else if (key === 'AmBank_TID') {
          configValue = olarconfig.Testing.AmBank.TID;
        } else if (key === 'AmBank_MerchantAccountNo') {
          configValue = olarconfig.Testing.AmBank.MerchantAccountNo;
        } else if (key === 'AmBank_TxnPassword') {
          configValue = olarconfig.Testing.AmBank.TxnPassword;
        } else if (key === 'AmBank_PaymentType') {
          configValue = olarconfig.Testing.AmBank.PaymentType;
        } else if (key === 'AmBank_AllowSales') {
          configValue = olarconfig.Testing.AmBank.AllowSales;
        } else if (key === 'AmBank_UseOwnMPI') {
          configValue = olarconfig.Testing.AmBank.UseOwnMPI;
        } else if (key === 'AmBank_Is3DEnabled') {
          configValue = olarconfig.Testing.AmBank.Is3DEnabled;
        } else if (key === 'AmBank_sale_url') {
          configValue = olarconfig.Testing.AmBank.sale_url;
        } else if (key === 'AmBank_return_url') {
          configValue = olarconfig.Testing.AmBank.return_url;
        } else if (key === 'ipgeolocation_key') {
          configValue = olarconfig.Testing.ipgeolocation_key;
        } else if (key === 'checkoutexpiryInMins') {
          configValue = olarconfig.Testing.checkoutexpiryInMins;
        } else if (key === 'cartexpiryInMins') {
          configValue = olarconfig.Testing.cartexpiryInMins;
        } else if (key === 'PaymentGateway') {
          configValue = olarconfig.Testing.PaymentGateway;
        } else if (key === 'ghl_merchant_id') {
          configValue = olarconfig.Testing.GHL.merchant_id;
        } else if (key === 'ghl_password') {
          configValue = olarconfig.Testing.GHL.password;
        } else if (key === 'ghl_merchantreturnurl') {
          configValue = olarconfig.Testing.GHL.merchantreturnurl;
        } else if (key === 'ghl_merchantcallbackurl') {
          configValue = olarconfig.Testing.GHL.merchantcallbackurl;
        } else if (key === 'ghl_paymentrequesturl') {
          configValue = olarconfig.Testing.GHL.paymentrequesturl;
        } else if (key === 'ghl_timeout') {
          configValue = olarconfig.Testing.GHL.timeout;
        } else if (key === 'ghl_merchantapprovedurl') {
          configValue = olarconfig.Testing.GHL.merchantapprovedurl;
        } else if (key === 'ghl_merchantunapprovedurl') {
          configValue = olarconfig.Testing.GHL.merchantunapprovedurl;
        } else if (key === 'FACEBOOK_APP_ID') {
          configValue = olarconfig.Testing.FACEBOOK_APP_ID;
        } else if (key === 'GOOGLE_APP_ID') {
          configValue = olarconfig.Testing.GOOGLE_APP_ID;
        } else if (key === 'PREFIX_ROUTING') {
          configValue = olarconfig.Testing.PREFIX_ROUTING;
        }
        break;
      case 'Staging':
        if (key === 'merchantmate') {
          configValue = olarconfig.Staging.merchantmate;
        } else if (key === 'serverurl') {
          configValue = olarconfig.Staging.serverurl;
        } else if (key === 'azureapi_azureprimarykey') {
          configValue = olarconfig.Staging.azureapi.azureprimarykey;
        } else if (key === 'azureapi_azureapiversion') {
          configValue = olarconfig.Staging.azureapi.azureapiversion;
        } else if (key === 'googleapi_gogetapitoken') {
          configValue = olarconfig.Staging.googleapi.gogetapitoken;
        } else if (key === 'googleapi_googlemapsapikey') {
          configValue = olarconfig.Staging.googleapi.googlemapsapikey;
        } else if (key === 'rhPayments_merchant_id') {
          configValue = olarconfig.Staging.rhPayments.merchant_id;
        } else if (key === 'rhPayments_merchant_key_key_index1') {
          configValue = olarconfig.Staging.rhPayments.merchant_key.key_index1;
        } else if (key === 'rhPayments_merchant_key_key_index2') {
          configValue = olarconfig.Staging.rhPayments.merchant_key.key_index2;
        } else if (key === 'rhPayments_merchant_key_key_index3') {
          configValue = olarconfig.Staging.rhPayments.merchant_key.key_index3;
        } else if (key === 'rhPayments_paymentfrontreturnurl') {
          configValue = olarconfig.Staging.rhPayments.paymentfrontreturnurl;
        } else if (key === 'rhPayments_paymentbackendurl') {
          configValue = olarconfig.Staging.rhPayments.paymentbackendurl;
        }
        else if (key === 'rhPayments_paymentrequesturl') {
          configValue = olarconfig.Staging.rhPayments.paymentrequesturl;
        } else if (key === 'rhPayments_paymentrequeryurl') {
          //configValue = olarconfig.Staging.rhPayments.paymentrequeryurl;
        } else if (key === 'cookiename') {
          configValue = olarconfig.Staging.cookiename;
        } else if (key === 'logconsole') {
          configValue = olarconfig.Staging.logconsole;
        } else if (key === 'AmBank_MerchantName') {
          configValue = olarconfig.Staging.AmBank.MerchantName;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Staging.AmBank.MID;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Staging.AmBank.MID;
        } else if (key === 'AmBank_TID') {
          configValue = olarconfig.Staging.AmBank.TID;
        } else if (key === 'AmBank_MerchantAccountNo') {
          configValue = olarconfig.Staging.AmBank.MerchantAccountNo;
        } else if (key === 'AmBank_TxnPassword') {
          configValue = olarconfig.Staging.AmBank.TxnPassword;
        } else if (key === 'AmBank_PaymentType') {
          configValue = olarconfig.Staging.AmBank.PaymentType;
        } else if (key === 'AmBank_AllowSales') {
          configValue = olarconfig.Staging.AmBank.AllowSales;
        } else if (key === 'AmBank_UseOwnMPI') {
          configValue = olarconfig.Staging.AmBank.UseOwnMPI;
        } else if (key === 'AmBank_Is3DEnabled') {
          configValue = olarconfig.Staging.AmBank.Is3DEnabled;
        } else if (key === 'AmBank_sale_url') {
          configValue = olarconfig.Staging.AmBank.sale_url;
        } else if (key === 'AmBank_return_url') {
          configValue = olarconfig.Staging.AmBank.return_url;
        } else if (key === 'ipgeolocation_key') {
          configValue = olarconfig.Staging.ipgeolocation_key;
        } else if (key === 'checkoutexpiryInMins') {
          configValue = olarconfig.Staging.checkoutexpiryInMins;
        } else if (key === 'cartexpiryInMins') {
          configValue = olarconfig.Staging.cartexpiryInMins;
        } else if (key === 'PaymentGateway') {
          configValue = olarconfig.Staging.PaymentGateway;
        } else if (key === 'ghl_merchant_id') {
          configValue = olarconfig.Staging.GHL.merchant_id;
        } else if (key === 'ghl_password') {
          configValue = olarconfig.Staging.GHL.password;
        } else if (key === 'ghl_merchantreturnurl') {
          configValue = olarconfig.Staging.GHL.merchantreturnurl;
        } else if (key === 'ghl_merchantcallbackurl') {
          configValue = olarconfig.Staging.GHL.merchantcallbackurl;
        } else if (key === 'ghl_paymentrequesturl') {
          configValue = olarconfig.Staging.GHL.paymentrequesturl;
        } else if (key === 'ghl_timeout') {
          configValue = olarconfig.Staging.GHL.timeout;
        } else if (key === 'ghl_merchantapprovedurl') {
          configValue = olarconfig.Staging.GHL.merchantapprovedurl;
        } else if (key === 'ghl_merchantunapprovedurl') {
          configValue = olarconfig.Staging.GHL.merchantunapprovedurl;
        } else if (key === 'FACEBOOK_APP_ID') {
          configValue = olarconfig.Staging.FACEBOOK_APP_ID;
        } else if (key === 'GOOGLE_APP_ID') {
          configValue = olarconfig.Staging.GOOGLE_APP_ID;
        } else if (key === 'PREFIX_ROUTING') {
          configValue = olarconfig.Staging.PREFIX_ROUTING;
        }
        break;
      case 'Production':
        if (key === 'merchantmate') {
          configValue = olarconfig.Production.merchantmate;
        } else if (key === 'serverurl') {
          configValue = olarconfig.Production.serverurl;
        } else if (key === 'azureapi_azureprimarykey') {
          configValue = olarconfig.Production.azureapi.azureprimarykey;
        } else if (key === 'azureapi_azureapiversion') {
          configValue = olarconfig.Production.azureapi.azureapiversion;
        } else if (key === 'googleapi_gogetapitoken') {
          configValue = olarconfig.Production.googleapi.gogetapitoken;
        } else if (key === 'googleapi_googlemapsapikey') {
          configValue = olarconfig.Production.googleapi.googlemapsapikey;
        } else if (key === 'rhPayments_merchant_id') {
          configValue = olarconfig.Production.rhPayments.merchant_id;
        } else if (key === 'rhPayments_merchant_key_key_index1') {
          configValue = olarconfig.Production.rhPayments.merchant_key.key_index1;
        } else if (key === 'rhPayments_merchant_key_key_index2') {
          configValue = olarconfig.Production.rhPayments.merchant_key.key_index2;
        } else if (key === 'rhPayments_merchant_key_key_index3') {
          configValue = olarconfig.Production.rhPayments.merchant_key.key_index3;
        } else if (key === 'rhPayments_paymentfrontreturnurl') {
          configValue = olarconfig.Production.rhPayments.paymentfrontreturnurl;
        } else if (key === 'rhPayments_paymentbackendurl') {
          configValue = olarconfig.Production.rhPayments.paymentbackendurl;
        }
        else if (key === 'rhPayments_paymentrequesturl') {
          configValue = olarconfig.Production.rhPayments.paymentrequesturl;
        } else if (key === 'rhPayments_paymentrequeryurl') {
          //configValue = olarconfig.Production.rhPayments.paymentrequeryurl;
        } else if (key === 'cookiename') {
          configValue = olarconfig.Production.cookiename;
        } else if (key === 'logconsole') {
          configValue = olarconfig.Production.logconsole;
        } else if (key === 'AmBank_MerchantName') {
          configValue = olarconfig.Production.AmBank.MerchantName;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Production.AmBank.MID;
        } else if (key === 'AmBank_MID') {
          configValue = olarconfig.Production.AmBank.MID;
        } else if (key === 'AmBank_TID') {
          configValue = olarconfig.Production.AmBank.TID;
        } else if (key === 'AmBank_MerchantAccountNo') {
          configValue = olarconfig.Production.AmBank.MerchantAccountNo;
        } else if (key === 'AmBank_TxnPassword') {
          configValue = olarconfig.Production.AmBank.TxnPassword;
        } else if (key === 'AmBank_PaymentType') {
          configValue = olarconfig.Production.AmBank.PaymentType;
        } else if (key === 'AmBank_AllowSales') {
          configValue = olarconfig.Production.AmBank.AllowSales;
        } else if (key === 'AmBank_UseOwnMPI') {
          configValue = olarconfig.Production.AmBank.UseOwnMPI;
        } else if (key === 'AmBank_Is3DEnabled') {
          configValue = olarconfig.Production.AmBank.Is3DEnabled;
        } else if (key === 'AmBank_sale_url') {
          configValue = olarconfig.Production.AmBank.sale_url;
        } else if (key === 'AmBank_return_url') {
          configValue = olarconfig.Production.AmBank.return_url;
        } else if (key === 'ipgeolocation_key') {
          configValue = olarconfig.Production.ipgeolocation_key;
        } else if (key === 'checkoutexpiryInMins') {
          configValue = olarconfig.Production.checkoutexpiryInMins;
        } else if (key === 'cartexpiryInMins') {
          configValue = olarconfig.Production.cartexpiryInMins;
        } else if (key === 'PaymentGateway') {
          configValue = olarconfig.Production.PaymentGateway;
        } else if (key === 'ghl_merchant_id') {
          configValue = olarconfig.Production.GHL.merchant_id;
        } else if (key === 'ghl_password') {
          configValue = olarconfig.Production.GHL.password;
        } else if (key === 'ghl_merchantreturnurl') {
          configValue = olarconfig.Production.GHL.merchantreturnurl;
        } else if (key === 'ghl_merchantcallbackurl') {
          configValue = olarconfig.Production.GHL.merchantcallbackurl;
        } else if (key === 'ghl_paymentrequesturl') {
          configValue = olarconfig.Production.GHL.paymentrequesturl;
        } else if (key === 'ghl_timeout') {
          configValue = olarconfig.Production.GHL.timeout;
        } else if (key === 'ghl_merchantapprovedurl') {
          configValue = olarconfig.Production.GHL.merchantapprovedurl;
        } else if (key === 'ghl_merchantunapprovedurl') {
          configValue = olarconfig.Production.GHL.merchantunapprovedurl;
        } else if (key === 'FACEBOOK_APP_ID') {
          configValue = olarconfig.Production.FACEBOOK_APP_ID;
        } else if (key === 'GOOGLE_APP_ID') {
          configValue = olarconfig.Production.GOOGLE_APP_ID;
        } else if (key === 'PREFIX_ROUTING') {
          configValue = olarconfig.Production.PREFIX_ROUTING;
        }
        break;
    }
    return configValue;
  }


  setCookie(cname, cvalue, exhours = 1) {
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (exhours * 60 * 60 * 1000));
    const expires = ';expires=' + expiryDate['toGMTString']();
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    document.cookie = this.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }

  setCookieInDays(cname, cvalue, exDays = 1) {
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (exDays * 24 * 60 * 60 * 1000));
    const expires = ';expires=' + expiryDate['toGMTString']();
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    document.cookie = this.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }

  setCookieInMinutes(cname, cvalue, exmins = 30) {
    let expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (exmins * 60 * 1000));
    const expires = ';expires=' + expiryDate['toGMTString']();
    if (cvalue) {
      cvalue = Base64.encode(cvalue);
    }
    //cvalue = cvalue.replace(/[, ]+/g, " ").trim();
    document.cookie = this.GetOlarConfigValue('cookiename') + cname + '=' + (cvalue || '') + expires + '; path=/';
  }
  getCookie(cname) {
    var name = this.GetOlarConfigValue('cookiename') + cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let str = c.substring(name.length, c.length);
        if (str) {
          str = Base64.decode(str);
        }
        return str;
      }
    }
    return "";
  }

  delete_cookie(cname) {
    cname = this.GetOlarConfigValue('cookiename') + cname;
    document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }


  googleApiTrack(input) {
    this.httpPost(EcomNetworkUtils.POST_GOOGLEAPI_TRACK, input, '', false).subscribe((response) => {
    });
  }

  generateSHA256Hash(message) {
    return message;
  }


}


export const genericRetryStrategy = ({
  // 3 time retry
  maxRetryAttempts = 3,
  scalingDuration = 1000,
  //excludedStatusCodes = [400,401,403]
  excludedStatusCodes = [],
  // 401 unauthorized no need to retry
  urlname = ''
}: {
  maxRetryAttempts?: number,
  scalingDuration?: number,
  excludedStatusCodes?: number[],
  urlname?: string
} = {}) => (attempts: Observable<any>) => {
  return attempts.pipe(
    mergeMap((error, i) => {
      const retryAttempt = i + 1;
      // check if unauthorized then clear the client key and refresh the page
      if (error.status === 401) {
        console.log('unauthorized');
        localStorage.clear();
        sessionStorage.clear();
        location.reload();
      }
      // if maximum number of retries have been met
      // or response is a status code we don't wish to retry, throw error
      if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error.status)) {
        return throwError(error);
      }
      console.log(
        `Attempt ${retryAttempt}: retrying in ${retryAttempt *
        scalingDuration}ms : url ${urlname}`
      );
      // retry after 1s, 2s, etc...
      return timer(retryAttempt * scalingDuration);
    }),
    finalize(() => console.log('We are done!'))
  );
};
